import { selectBuildingCurrencyType } from 'store/building/selectors';
import { selectCartCurrencyType } from 'store/cart/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const DEFAULT_CURRENCY = 'USD';

export const useCurrencyType = (): string => {
  const buildingCurrencyType = useSelector(selectBuildingCurrencyType);
  const cartCurrencyType = useSelector(selectCartCurrencyType);

  return useMemo(() => {
    return buildingCurrencyType || cartCurrencyType || DEFAULT_CURRENCY;
  }, [buildingCurrencyType, cartCurrencyType]);
};
